import { ContentfulEntry, TranslatedContent, TranslationNamespace } from '../types';

export const isContentfulNamespace = (namespace: string): boolean =>
  namespace === TranslationNamespace.CONTENTFUL;

/** Empty CMS namespace lets pages render and show their own missing-content UI. */
export const getContentfulTranslationsOnReadFailure = (): TranslatedContent => ({});

export const mapContentfulEntries = (entries: ContentfulEntry[]): TranslatedContent =>
  entries.reduce((acc: TranslatedContent, entry: ContentfulEntry) => {
    return { ...acc, [entry.id]: entry };
  }, {});
